import { attachForm } from '../../formToolTypeHelper';
import definition from './definition.json';
import { form } from './form';
import presets from './Presets/index';

export default { definition: attachForm(definition, form), presets };
